import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Experience } from '../../interface/user-profile';
import { UserProfileService } from '../../service/user-profile.service';

@Component({
  selector: 'app-profile-experience',
  templateUrl: './profile-experience.component.html',
  styleUrls: ['./profile-experience.component.css'],
})
export class ProfileExperienceComponent implements OnChanges, OnInit {
  @Input() experience: Experience[] | null = [];
  @Input() mode: 'view' | 'edit' = 'view';

  isModalOpen = false;
  isEditing = false;
  editingIndex = -1;
  isSaving = false;
  expForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private userProfileService: UserProfileService,
  ) {}

  ngOnChanges(): void {}
  ngOnInit(): void {
    console.log(this.experience);
  }
  initForm(exp?: Experience): void {
    this.expForm = this.fb.group({
      company: [exp?.company || '', Validators.required],
      title: [exp?.title || '', Validators.required],
      location: [exp?.location || ''],
      description: [exp?.description || ''],
      startDate: [exp?.startDate || '', Validators.required],
      endDate: [exp?.endDate || ''],
      current: [!exp?.endDate],
    });

    // toggle endDate requirement based on current checkbox
    this.expForm.get('current')?.valueChanges.subscribe((isCurrent) => {
      if (isCurrent) {
        this.expForm.get('endDate')?.setValue('');
        this.expForm.get('endDate')?.clearValidators();
      } else {
        this.expForm.get('endDate')?.setValidators(Validators.required);
      }
      this.expForm.get('endDate')?.updateValueAndValidity();
    });
  }

  openAddModal(): void {
    this.isEditing = false;
    this.editingIndex = -1;
    this.initForm();
    this.isModalOpen = true;
  }

  openEditModal(exp: Experience, index: number): void {
    this.isEditing = true;
    this.editingIndex = index;
    this.initForm(exp);
    this.isModalOpen = true;
  }

  closeModal(): void {
    this.isModalOpen = false;
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      year: 'numeric',
    });
  }

  getPeriod(exp: Experience): string {
    const start = this.formatDate(exp.startDate);
    const end = exp.endDate ? this.formatDate(exp.endDate) : 'Present';
    return `${start} – ${end}`;
  }

  saveExperience(): void {
    if (!this.expForm.valid) {
      this.expForm.markAllAsTouched();
      return;
    }

    this.isSaving = true;
    const formValue = this.expForm.value;

    // Build updated list
    const updatedList: Experience[] = [...(this.experience || [])];
    const newExp: Experience = {
      company: formValue.company,
      title: formValue.title,
      location: formValue.location,
      description: formValue.description,
      startDate: formValue.startDate,
      endDate: formValue.current ? null : formValue.endDate,
    };

    if (this.isEditing && this.editingIndex >= 0) {
      updatedList[this.editingIndex] = newExp;
    } else {
      updatedList.push(newExp);
    }

    // FIXED: Use consistent parameter name 'experiencesJson'
    const formData = new FormData();
    formData.append('experiences', JSON.stringify(updatedList));

    this.userProfileService.updateUserProfile(formData).subscribe({
      next: (response) => {
        this.isSaving = false;
        this.experience = response.experiences ?? updatedList;
        this.closeModal();
      },
      error: (error) => {
        this.isSaving = false;
        console.error('Error updating experience:', error);
        alert('Failed to update. Please try again.');
      },
    });
  }

  deleteExperience(index: number): void {
    if (!confirm('Remove this experience?')) return;

    const updatedList = (this.experience || []).filter((_, i) => i !== index);
    const formData = new FormData();
    formData.append('experiences', JSON.stringify(updatedList));

    this.userProfileService.updateUserProfile(formData).subscribe({
      next: (response) => {
        this.experience = response.experiences ?? updatedList;
      },
      error: (error) => {
        console.error('Error deleting experience:', error);
        alert('Failed to delete. Please try again.');
      },
    });
  }

  get isCurrent(): boolean {
    return this.expForm?.get('current')?.value;
  }
}
